module.exports = __webpack_public_path__ + "6fbf13865f28342ea422fa342afad544.png";